import { createSelector } from 'reselect'

const getSlide = (state, slideId) => state.slides[slideId]

const slideDataSelector = createSelector(
	[ getSlide ],
	slide => slide
)

export default slideDataSelector
